import moment  from "moment";

export default class Util{
    //returns 5 days ago etc
    public static getSocialDate(time: number): string{
        let socialDate: string  = " sometime ago";
        if(time){
            socialDate = moment.unix(time).fromNow();
        }
        return socialDate;
    }

    public static getExactDate(time: number): string{
        let exactDate: string  = "";
        if(time){
            exactDate = moment.unix(time).format();
        }
        return exactDate;
    }
}